"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
var react_1 = __importDefault(require("react"));
/**
 * Wrap the app in this error boundary and any errors that are thrown outside of event handlers will be caught here.
 * This is useful for catching errors thrown when making requests to the API.
 */
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hasError: false,
            error: null,
        };
        return _this;
    }
    // Update state so the next render will show the fallback UI.
    ErrorBoundary.getDerivedStateFromError = function (error) {
        if (error) {
            return {
                hasError: true,
                error: error,
            };
        }
        return {
            hasError: false,
        };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        var onError = this.props.onError;
        // You can also log the error to an error reporting service
        if (onError) {
            onError(error, errorInfo);
        }
    };
    ErrorBoundary.prototype.render = function () {
        var children = this.props.children;
        var _a = this.state, error = _a.error, hasError = _a.hasError;
        if (hasError) {
            return children(error || undefined);
        }
        return children();
    };
    return ErrorBoundary;
}(react_1.default.Component));
exports.ErrorBoundary = ErrorBoundary;
